import { Link, NavLink, useNavigate } from "react-router-dom";
import { Newspaper, Tags, LogOut, ExternalLink, PenLine } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const item = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors ${isActive ? "bg-[#C8102E] text-white" : "text-slate-300 hover:bg-slate-800"}`;

export const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const out = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-slate-50">
      <aside className="md:w-60 bg-slate-950 text-white md:min-h-screen flex md:flex-col">
        <Link to="/" className="hidden md:block font-serif text-2xl font-extrabold px-6 py-6">Kabar<span className="text-[#C8102E]">Nusa</span></Link>
        <nav className="flex md:flex-col flex-1 overflow-x-auto">
          <NavLink to="/admin/berita" end className={item} data-testid="admin-nav-articles"><Newspaper size={16} /> Berita</NavLink>
          <NavLink to="/admin/berita/baru" className={item} data-testid="admin-nav-new"><PenLine size={16} /> Tulis Berita</NavLink>
          <NavLink to="/admin/kategori" className={item} data-testid="admin-nav-categories"><Tags size={16} /> Kategori</NavLink>
          <Link to="/" className="flex items-center gap-3 px-4 py-3 text-sm text-slate-300 hover:bg-slate-800" data-testid="admin-nav-site"><ExternalLink size={16} /> Lihat Situs</Link>
        </nav>
        <div className="md:border-t border-slate-800 p-2 md:p-4">
          <p className="hidden md:block text-xs text-slate-500 mb-2 truncate">{user?.email}</p>
          <button onClick={out} data-testid="admin-logout-button" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white px-2 py-1"><LogOut size={16} /> Keluar</button>
        </div>
      </aside>
      <main className="flex-1 p-6 sm:p-10">{children}</main>
    </div>
  );
};
